// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductReplacement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  confirmedTs?: Date;
  /** String(4) */
  confirmedUserInit?: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(4) */
  crtnUserInit!: string;
  /** DateTimeOffset */
  modTs!: Date;
  /** String(4) */
  modUserInit!: string;
  /** Int32 FK newProduct */
  newProductId!: number;
  /** Int32 FK oldProduct */
  oldProductId!: number;
  /** Binary */
  rowVersion!: any;
  /** FK newProductId */
  newProduct!: Product;
  /** FK oldProductId */
  oldProduct!: Product;
}

